angular
  .module('gridlets.module', []);
